import BaseLogModel from '../../../models/BaseLogModel';
import { BaseQuerySingleInputModel } from '../../../models/BaseQueryInputModel';
import { HasuraOrderByInputModel } from '../../../models/HasuraOrderByInputModel';
import { HasuraRefModel } from '../../../models/HasuraRefModel';
import MasterDataCountry, { MasterDataCountryOrderByInput } from '../../countries/models/MasterDataCountry';
import MasterDataLanguage, { MasterDataLanguageOrderByInput } from '../../languages/models/MasterDataLanguage';
import MasterDataPerson from '../../users/models/MasterDataPerson';
import Widget from '../../widgets/interfaces/Widget';
import MasterDataEventType, { MasterDataEventTypeOrderByInput } from './MasterDataEventType';

export enum MasterEventsView {
  Table = 'table',
  Grid = 'grid',
}

export interface MasterEventCoverImage {
  unsplashId?: string;
  unsplashLink?: string;
  unsplashUserName?: string;
  unsplashUserUrl?: string;
  urlFull: string;
  urlRegular: string;
}

export interface MasterEventGuestsStats {
  total: number;
  totalRsvped: number;
  totalCheckedIn: number;
  totalCheckedOut?: number;
}

export default interface MasterEvent extends BaseLogModel {
  _id: string;
  admins: MasterDataPerson[];
  archivedAt?: Date;
  campaignId?: string;
  card?: string;
  country?: MasterDataCountry;
  coverImage?: MasterEventCoverImage;
  devices: string[];
  endAt: Date;
  isArchived?: boolean;
  language?: MasterDataLanguage;
  name: string;
  secondCard?: string;
  startAt: Date;
  type?: MasterDataEventType;
  userLanguage?: MasterDataLanguage;
  widgets?: Widget[];
}

// Hasura GraphQL resolvers

export interface MasterEventUpdateInput
  extends Partial<Omit<MasterEvent, 'admins' | 'country' | 'type' | 'language' | 'userLanguage'>> {
  adminIds?: MasterDataPerson['_id'][];
  countryId?: MasterDataCountry['_id'];
  languageId?: MasterDataLanguage['_id'];
  typeId?: MasterDataEventType['_id'];
  userLanguageId?: MasterDataLanguage['_id'];
}

export interface MasterEventInsertInput
  extends Omit<MasterEvent, 'admins' | 'country' | 'language' | 'userLanguage' | 'type'> {
  adminIds?: MasterDataPerson['_id'][];
  countryId?: MasterDataCountry['_id'];
  languageId?: MasterDataLanguage['_id'];
  typeId?: MasterDataEventType['_id'];
  userLanguageId?: MasterDataLanguage['_id'];
}

export interface MasterEventQuerySingleInput extends BaseQuerySingleInputModel {}

export interface MasterEventOrderByInput extends HasuraOrderByInputModel<MasterEvent> {
  country?: MasterDataCountryOrderByInput;
  coverImage?: HasuraOrderByInputModel<MasterEventCoverImage>;
  guests?: HasuraOrderByInputModel<MasterEventGuestsStats>;
  language?: MasterDataLanguageOrderByInput;
  type?: MasterDataEventTypeOrderByInput;
  userLanguage?: MasterDataLanguageOrderByInput;
}

export type MasterEventRef = HasuraRefModel<MasterEvent>;
